'use client';
import React, { useState, useEffect } from 'react';
import { Carousel, Container } from 'react-bootstrap';
import './solutionSection.scss';
import { LANDING_OR_PRODUCT_PAGE_QUERY_RESULT } from '@/sanity.types';
import FontAwesomeIcon from '@/componentv2/fontAwesomeIcon/fontAwesomeIcon';
import Typography from '@/componentv2/typography/typography';

interface AudienceSectionProps {
  data: NonNullable<LANDING_OR_PRODUCT_PAGE_QUERY_RESULT>;
}

type ProductPageData = Extract<
  AudienceSectionProps['data'],
  { _type: 'productPage' }
>;

type AudienceItem = NonNullable<
  NonNullable<ProductPageData['audienceTiles']>['audiences']
>[0];

const SolutionCard = ({
  solution,
  backgroundColor,
}: {
  solution: AudienceItem;
  backgroundColor?: string;
}) => {
  return (
    <div
      className="solution-card"
      style={{
        backgroundColor: backgroundColor,
      }}
    >
      <FontAwesomeIcon
        style={solution?.icon?.style}
        name={solution?.icon?.name}
        fontSize="40px"
      />
      <Typography style="h4">{solution?.audience}</Typography>
      <Typography style="paragraph">{solution?.description}</Typography>
    </div>
  );
};
export default function SolutionSection({ data }: AudienceSectionProps) {
  const audienceContent =
    data?._type === 'productPage' ? data?.audienceTiles : null;

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);
  return (
    <section className="solution-section">
      <Container>
        {audienceContent?.label && (
          <Typography as="h2" style="eyebrow-badge">
            {audienceContent?.label}
          </Typography>
        )}
        {isMobile ? (
          <Carousel
            indicators={true}
            controls={false}
            interval={3000}
            slide={true}
            fade={false}
            pause="hover"
            className="new-home-carousel"
          >
            {audienceContent?.audiences?.map((solution, index) => (
              <Carousel.Item key={index}>
                <SolutionCard
                  solution={solution}
                  backgroundColor={audienceContent?.featuredColor?.value}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <div className="solution-cards-row">
            {audienceContent?.audiences?.map((solution, index) => (
              <SolutionCard
                key={index}
                solution={solution}
                backgroundColor={audienceContent?.featuredColor?.value}
              />
            ))}
          </div>
        )}
      </Container>
    </section>
  );
}
